"use client"

import { CircleArrowOutDownRight } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `CircleArrowOutDownRightIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const CircleArrowOutDownRightIcon = component(Icon)({
  as: CircleArrowOutDownRight,
})
